import React from "react";
import { useNavigate } from "react-router-dom";

const ThighFrontPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .thigh-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #eef2ff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .thigh-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .thigh-hero {
          padding: 26px 22px 30px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(129, 140, 248, 0.18), rgba(59, 130, 246, 0.05));
          margin-bottom: 32px;
          display: grid;
          grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .thigh-hero {
            grid-template-columns: 1fr;
          }
        }

        .thigh-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(129, 140, 248, 0.22);
          color: #3730a3;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .thigh-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #4f46e5;
        }

        .thigh-title {
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 8px;
        }

        .thigh-subtitle {
          font-size: 15px;
          max-width: 540px;
          color: #374151;
        }

        .thigh-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .thigh-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .thigh-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .thigh-btnPrimary,
        .thigh-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .thigh-btnPrimary {
          background: #4f46e5;
          color: #f9fafb;
          box-shadow: 0 9px 22px rgba(79, 70, 229, 0.38);
        }

        .thigh-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(79, 70, 229, 0.5);
        }

        .thigh-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .thigh-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .thigh-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .thigh-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* STRIPES */
        .thigh-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .thigh-sectionTitle {
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .thigh-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .thigh-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .thigh-flexCol {
          flex: 1 1 260px;
        }

        .thigh-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        .thigh-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .thigh-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .thigh-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #4f46e5;
          flex-shrink: 0;
        }

        /* CARDS */
        .thigh-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .thigh-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .thigh-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .thigh-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE */
        .thigh-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .thigh-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .thigh-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .thigh-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .thigh-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .thigh-banner img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .thigh-banner img {
            height: 260px;
          }
        }

        .thigh-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.8), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .thigh-bannerText {
          color: #e0e7ff;
          font-size: 15px;
          max-width: 420px;
        }

        .thigh-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .thigh-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .thigh-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .thigh-bannerButtons .secondary {
          background: rgba(255, 255, 255, 0.18);
          color: #f9fafb;
          border: 1px solid rgba(255, 255, 255, 0.6);
        }

        /* BOTTOM STRIP */
        .thigh-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .thigh-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .thigh-bottomText strong {
          color: #fef9c3;
        }

        .thigh-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .thigh-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .thigh-bottomActions .primary {
          background: #4f46e5;
          color: #f9fafb;
        }

        .thigh-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .thigh-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="thigh-page">
        <div className="thigh-inner">
          {/* HERO */}
          <section className="thigh-hero">
            <div>
              <div className="thigh-tag">
                <span className="thigh-tagDot" />
                Front Thigh · Quads & Hip Flexors
              </div>
              <h1 className="thigh-title">
                Ease front thigh and hip flexor pain so walking, stairs, and workouts feel doable again.
              </h1>
              <p className="thigh-subtitle">
                The quadriceps, hip flexors, and IT band help you stand, walk, squat, and climb.
                When they’re tight or overloaded, even simple motions can light up the front of the thigh.
              </p>

              <div className="thigh-chips">
                <span className="thigh-chip">Quad tightness or burning</span>
                <span className="thigh-chip">Hip flexor pinching</span>
                <span className="thigh-chip">IT band tension</span>
                <span className="thigh-chip">Pain with stairs or squats</span>
              </div>

              <div className="thigh-ctaRow">
                <button
                  className="thigh-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a front thigh visit →
                </button>
                <button
                  className="thigh-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="thigh-heroImgWrap">
              <img
                src="/content/thigh-front/thigh_front_hero.png"
                alt="Therapist assessing the front thigh and quadriceps"
                className="thigh-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="thigh-stripe">
            <div className="thigh-sectionTitle">What can go wrong in the front thigh?</div>
            <p className="thigh-sectionSubtitle">
              The front thigh isn&apos;t just one muscle. The quads, hip flexors, and IT band all
              share load every time you stand, walk, and climb.
            </p>

            <div className="thigh-flexRow">
              <div className="thigh-flexCol">
                <ul className="thigh-list">
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Quad strain or overload:</strong> soreness across the front of the thigh,
                      often after squats, running, or sudden increases in activity.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Hip flexor irritation:</strong> tightness or sharp feelings high in the
                      front of the thigh, especially when bringing the knee up.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>IT band tension:</strong> outer thigh pulling or pressure that may link
                      to the hip or knee.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Post-surgery or post-injury stiffness:</strong> difficulty bending or
                      straightening the knee fully after an injury or procedure.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Strength imbalance:</strong> quads working harder than hips or glutes,
                      leading to front-of-thigh fatigue and tightness.
                    </span>
                  </li>
                </ul>

                <div className="thigh-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="thigh-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your thigh symptoms fit →
                  </button>
                  <button
                    className="thigh-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="thigh-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/thigh-front/thigh_quadriceps_assessment.png"
                  alt="Therapist assessing quadriceps strength and tenderness"
                  className="thigh-img"
                />
              </div>
            </div>

            <div className="thigh-cardGrid">
              <div className="thigh-card">
                <div className="thigh-cardTitle">Quadriceps group</div>
                <div className="thigh-cardText">
                  Rectus femoris, vastus lateralis, medialis, and intermedius extend the knee and help control squats and stairs.
                </div>
              </div>
              <div className="thigh-card">
                <div className="thigh-cardTitle">Hip flexors</div>
                <div className="thigh-cardText">
                  Front-hip muscles that lift your knee and help control walking and running.
                </div>
              </div>
              <div className="thigh-card">
                <div className="thigh-cardTitle">IT band & outer thigh</div>
                <div className="thigh-cardText">
                  A thick band of tissue along the outer thigh that helps with stability but can feel tight or overworked.
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="thigh-stripe">
            <div className="thigh-flexRow">
              <div className="thigh-flexCol">
                <img
                  src="/content/thigh-front/thigh_hip_flexor.png"
                  alt="Therapist stretching front thigh and hip flexors"
                  className="thigh-img"
                />
              </div>

              <div className="thigh-flexCol">
                <div className="thigh-sectionTitle">How physical therapy helps the front thigh</div>
                <p className="thigh-sectionSubtitle">
                  We look at how your thigh, hips, and core share the work, then create a plan to calm irritation and
                  rebuild strength.
                </p>

                <ul className="thigh-list">
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Targeted soft-tissue work:</strong> to quads, hip flexors, and outer thigh to reduce tight, guarded areas.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Range-of-motion work:</strong> restoring comfortable knee bending and straightening with control.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Strength balance:</strong> helping hips and glutes share load so the quads don&apos;t do everything.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Load progression:</strong> gradually returning to stairs, squats, and workouts without big flare-ups.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      <strong>Movement coaching:</strong> finding knee and hip positions that feel stronger and safer.
                    </span>
                  </li>
                </ul>

                <div className="thigh-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="thigh-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start with one thigh session →
                  </button>
                  <button
                    className="thigh-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* IT BAND / OUTER THIGH FOCUS */}
          <section className="thigh-stripe">
            <div className="thigh-flexRow">
              <div className="thigh-flexCol">
                <div className="thigh-sectionTitle">What about the IT band?</div>
                <p className="thigh-sectionSubtitle">
                  The IT band itself doesn&apos;t stretch much, but the muscles around it absolutely can change how it feels.
                </p>

                <ul className="thigh-list">
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      Focusing on TFL and glute muscles that connect into the IT band.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      Adjusting running, walking, and squat form to reduce outer thigh strain.
                    </span>
                  </li>
                  <li>
                    <span className="thigh-bullet" />
                    <span>
                      Adding strength in directions you may not usually train (side steps, hip shifts, etc.).
                    </span>
                  </li>
                </ul>

                <div className="thigh-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="thigh-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Talk about your IT band →
                  </button>
                </div>
              </div>

              <div className="thigh-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/thigh-front/thigh_itband.png"
                  alt="Therapist treating outer thigh and IT band region"
                  className="thigh-img"
                />
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="thigh-stripe">
            <div className="thigh-sectionTitle">What a front thigh session may look like</div>

            <div className="thigh-flexRow">
              <div className="thigh-flexCol">
                <img
                  src="/content/thigh-front/thigh_strength_exercises.png"
                  alt="Patient performing front thigh and hip strengthening exercises"
                  className="thigh-img"
                />
              </div>

              <div className="thigh-flexCol">
                <div className="thigh-timeline">
                  <div className="thigh-step">
                    <div className="thigh-stepLabel">1. Your story</div>
                    <div className="thigh-stepText">
                      Where does it hurt? When does it show up—stairs, squats, walking, or sitting?
                    </div>
                  </div>
                  <div className="thigh-step">
                    <div className="thigh-stepLabel">2. Motion & strength check</div>
                    <div className="thigh-stepText">
                      We look at thigh strength, hip motion, and how your leg lines up over your foot.
                    </div>
                  </div>
                  <div className="thigh-step">
                    <div className="thigh-stepLabel">3. Hands-on work</div>
                    <div className="thigh-stepText">
                      You try focused manual techniques and stretches to see what eases tightness or pain.
                    </div>
                  </div>
                  <div className="thigh-step">
                    <div className="thigh-stepLabel">4. Short home plan</div>
                    <div className="thigh-stepText">
                      You leave with a few clear moves (not a long list) that build confidence and strength.
                    </div>
                  </div>
                </div>

                <div className="thigh-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="thigh-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a front thigh evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="thigh-stripe">
            <div className="thigh-banner">
              <img
                src="/content/thigh-front/thigh_front_banner.png"
                alt="Bright physical therapy clinic for leg and thigh rehab"
              />
              <div className="thigh-bannerOverlay">
                <div className="thigh-bannerText">
                  Front thigh sessions happen in a calm, one-on-one environment where we match your
                  plan to your comfort level, activity goals, and timeline.
                </div>
                <div className="thigh-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule front thigh visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="thigh-stripe">
            <div className="thigh-bottomStrip">
              <div className="thigh-bottomText">
                If you notice sudden severe thigh pain after a fall, can&apos;t bear weight, see
                major swelling or deformity, or have symptoms like fever, chest pain, or shortness
                of breath,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help
                guide your recovery and return to walking, stairs, and activity.
              </div>
              <div className="thigh-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule thigh PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default ThighFrontPT;
